// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"2919dbd9","551":"421b9938","576":"2919dbd9","678":"421b9938","735":"421b9938","914":"421b9938"}[chunkId] + ".chunk.css";
};